(() => {
 if (!document.body.classList.contains('mce-buy')) return;
 const selected = () => {
  const group=document.querySelector('quantity-breaks');
  const radio=group?.querySelector('input[type="radio"]:checked');
  const card=radio && group.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
  return [...(card?.querySelectorAll('select') || [])];
 };
 window.mceBuySelectionValid = () => { const fields=selected(); return fields.length>0 && fields.every(s=>s.value && s.dataset.mceChosen==='true' && !s.selectedOptions[0]?.classList.contains('unavailable') && /^\d+$/.test(s.closest('.quantity-break__selector-item')?.dataset.selectedId || '')); };
 // Shopify標準フォームへ、主商品と追加商品を原子的に同期する。
 const syncAccelerated = valid => {
  const form=document.querySelector('product-form.main-product-form form'); if(!form)return;
  const id=form.querySelector('input[name="id"]'); if(!id)return;
  let fields=form.querySelector('[data-mce-accelerated-fields]');
  if(!fields){fields=document.createElement('div');fields.hidden=true;fields.dataset.mceAcceleratedFields='';form.append(fields);}
  const grouped=new Map();
  if(valid)for(const select of selected()){const key=select.closest('.quantity-break__selector-item').dataset.selectedId;grouped.set(key,(grouped.get(key)||0)+1);}
  const items=[...grouped];
  const signature=JSON.stringify(items);
  if(fields.dataset.signature!==signature){
   fields.dataset.signature=signature;fields.replaceChildren();
   const add=(name,value)=>{const input=document.createElement('input');input.type='hidden';input.name=name;input.value=String(value);fields.append(input);};
   id.value=items[0]?.[0]||'';
   add('quantity',items[0]?.[1]||1);
   items.slice(1).forEach(([variant,quantity],index)=>{add(`shopify-additional-items[${index+1}][id]`,variant);add(`shopify-additional-items[${index+1}][quantity]`,quantity);});
   id.dispatchEvent(new Event('change',{bubbles:true}));
  }
  const wallet=form.querySelector('shopify-accelerated-checkout');
  let prime=false;try{prime=/prime/i.test(JSON.parse(wallet?.getAttribute('recommended')||'null')?.name||'');}catch{}
  const incompatible=items.length>1&&prime;
  const payment=form.querySelector('.shopify-payment-button');
  if(payment){payment.hidden=!valid||incompatible;payment.inert=!valid||incompatible;}
 };
 const sync = () => {
  const valid=window.mceBuySelectionValid();
  syncAccelerated(valid);
  document.body.classList.toggle('mce-buy-unselected',!valid);
  document.querySelectorAll('product-form [type="submit"], [id^="StickyAtcSubmitButton"]').forEach(b=>{
   if (!valid) { b.disabled=true; b.dataset.mceSelectionLock=''; }
   else if (b.hasAttribute('data-mce-selection-lock')) { b.disabled=b.dataset.unavailable==='true' || selected().some(s=>s.selectedOptions[0]?.classList.contains('unavailable')); b.removeAttribute('data-mce-selection-lock'); }
  });
  const note=document.getElementById('mce-selection-hint'); if(note)note.hidden=valid;
 };
 const init=()=>{
  document.querySelectorAll('quantity-breaks select').forEach(s=>{if(!s.dataset.mceInit){s.dataset.mceInit='true';s.value='';s.dataset.mceChosen='false';}});
  sync();
 };
 document.addEventListener('change',e=>{
  if(!e.target.closest('quantity-breaks'))return;
  if(e.target.matches('select')) e.target.dataset.mceChosen=e.target.value?'true':'false';
  queueMicrotask(sync);
 });
 document.addEventListener('submit',e=>{if(e.target.closest('product-form')&&!window.mceBuySelectionValid()){e.preventDefault();e.stopImmediatePropagation();selected().find(s=>!s.value||s.dataset.mceChosen!=='true')?.focus();}},true);
 document.addEventListener('click',e=>{if(e.target.closest('product-form [type="submit"], [id^="StickyAtcSubmitButton"], .shopify-payment-button')&&!window.mceBuySelectionValid()){e.preventDefault();e.stopImmediatePropagation();}},true);
 document.addEventListener('shopify:section:load',init);
 window.addEventListener('pageshow',sync);
 init();
})();
